import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface UseGetTaskListProps {
  projectId: string;
  planId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTaskList = async (planId: string, projectId: string) =>
  await axiosAuth.get(`${PROJECT_API}/${projectId}/plans/${planId}/tasks`);

const useGetTaskList = ({
  planId,
  projectId,
  queryParams,
}: UseGetTaskListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["task-list", planId],
    queryFn: () => getTaskList(planId, projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetTaskList;
